/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'react-hot-toast';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en.json';

import './index.css';
import 'react-circular-progressbar/dist/styles.css';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './app/store';
import reportWebVitals from './reportWebVitals';
import App from './App';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-quill/dist/quill.snow.css';

// Suppress noisy console logs in production (material-table debug logs)
if (process.env.NODE_ENV === 'production') {
  const originalConsoleLog = console.log;
  const originalConsoleWarn = console.warn;

  console.log = (...args) => {
    // Filter out material-table debug logs
    const firstArg = args[0];
    if (
      typeof firstArg === 'object' &&
      firstArg !== null &&
      ('actions' in firstArg || 'originalData' in firstArg)
    ) {
      return; // Suppress material-table debug logs
    }
    originalConsoleLog.apply(console, args);
  };

  console.warn = (...args) => {
    // Filter out material-table deprecation warnings
    const firstArg = args[0];
    if (
      typeof firstArg === 'string' &&
      firstArg.includes('has been deprecated')
    ) {
      return; // Suppress deprecation warnings
    }
    originalConsoleWarn.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));

TimeAgo.addDefaultLocale(en);

const queryClient = new QueryClient();

const theme = createTheme({
  palette: {
    primary: {
      main: '#8B173B',
    },
    secondary: {
      main: '#00999E',
    },
  },
});

const toastOptions = {
  duration: 3000,
};

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <QueryClientProvider client={queryClient}>
            <App />
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
          <Toaster toastOptions={toastOptions} />
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
